import styled from "styled-components";

export const StyledInput = styled.div<{invalid: boolean}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #F4F4F4;

  &.disabled {
    background-color: #e2e2e2;
    color: #828282;
  }

  .custom-input-style {
    width: 100%;
    display: inline-block;
    border: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: inherit;

    &:focus {
      outline: none;
    }
  }


  .error {
    font-size: 12px;
    color: #ff6969;
    position: absolute;
    bottom: -16px;
  }

  .addon {
    background-color: inherit;
  }
`;